const monthMap: Record<string, number> = {
    Jan: 0, Feb: 1, Mar: 2, Apr: 3,
    May: 4, Jun: 5, Jul: 6, Aug: 7,
    Sep: 8, Oct: 9, Nov: 10, Dec: 11,
};

export function parseMonthYearToUTCDate(input: string): string {
    const [mon, yearStr] = input.split('-');
    const year = parseInt(yearStr);
    const monthIndex = monthMap[mon];
    return new Date(Date.UTC(year, monthIndex, 1)).toISOString();
}